export default __webpack_public_path__ + "static/media/power-off-start.785c72b1.png";